<template>
    <div>
        <b-form @submit.prevent="saveTypeTipPrudence()" data-vv-scope="formTypeTipPrudence">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="typeTipPrudence.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formTypeTipPrudence.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in typeTipPrudence.sga_prudence_tip_type_languages"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelTypeTipPrudence">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormTypesTipPrudence',

    computed: {
        ...mapState('sgaTypesTipPrudence', ['action', 'typeTipPrudence']),

        hasValidLanguages() {
            return Array.isArray(this.typeTipPrudence.sga_prudence_tip_type_languages) &&
                this.typeTipPrudence.sga_prudence_tip_type_languages.length > 0;
        },
    },

    methods: {
        ...mapActions('sgaTypesTipPrudence', ['createTypeTipPrudenceSga', 'getTypesTipPrudenceSga', 'updateTypeTipPrudenceSga']),
        ...mapMutations('sgaTypesTipPrudence', ['setDefaultTypeTipPrudenceSga']),

        cancelTypeTipPrudence() {
            this.setDefaultTypeTipPrudenceSga();
            this.$bvModal.hide('modal_create_typetipprudence');
        },

        async cancelAndGetTypesTipPrudence() {
            this.cancelTypeTipPrudence();
            await this.getTypesTipPrudenceSga();
        },

        async saveTypeTipPrudence() {
            const isValid = await this.$validator.validateAll('formTypeTipPrudence');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateTypeTipPrudenceSga(this.typeTipPrudence);
            } else {
                flag = await this.createTypeTipPrudenceSga(this.typeTipPrudence);
            }

            if (flag) {
                this.cancelAndGetTypesTipPrudence();
            }
        }
    }
}
</script>
